import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * concentrator 列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	concentratorList( params={} ) {
		return request({
	    url: baseUrl + '/device/concentrator',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * concentrator 添加
	**/
	concentratorAdd(data){
		return request({
			url: baseUrl + '/device/concentrator',
			method:'POST',
			data
		})
	},

	/**
	 * concentrator 编辑
	**/
	concentratorEdit(id,data){
		return request({
			url: baseUrl + '/device/concentrator/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * concentrator 删除
	**/
	concentratorDel(id){
		return request({
			url: baseUrl + '/device/concentrator/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 回路控制
	 * @param {id} 网关ID
	**/
	loopControl(id,data){
		return request({
			url: baseUrl + '/device/concentrator/lampLoopControl/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 回路列表
	 * @param {id} 网关ID
	**/
	loopList(id) {
		return request({
	    url: baseUrl + '/device/concentrator/getLoopList/'+id,
	    method: 'GET'
	  })
	},

	/**
	 * 获取集中控制器的每个回路的三相电等数据
	 * @param {id} 网关ID
	**/
	loopPower(id){
		return request({
			url: baseUrl + '/device/concentrator/getSensor/'+id,
			method: 'GET'
		})
	}
}